module.exports = __webpack_public_path__ + "img/logo1.24045ce5.png";